import { Component } from '@angular/core';

/**
 * The debug log as a page in its own right. Hosts that already provide their own
 * abs-page-layout should route to DebugPanelComponent instead, otherwise the page
 * chrome ends up nested inside the host's chrome.
 */
@Component({
    standalone: false,
    selector: 'abs-debug',
    template: `
        <abs-page-layout [pageTitle]="'GLOBAL.SETTINGS.DEBUG.TITLE' | translate">
            <abs-debug-panel></abs-debug-panel>
        </abs-page-layout>
    `
})
export class DebugComponent {}
